import classnames from 'classnames';

import style from './BlockItem.module.scss';

export interface BlockItemProps {}

interface Props extends BlockItemProps {
    title: string;
    isSelected: boolean;
    onClick(): void;
}

export function BlockItem({ title, isSelected, onClick }: Props) {
    return (
        <div
            className={classnames([style.root, isSelected && style.selected])}
            onClick={isSelected ? undefined : onClick}
        >
            {title}
        </div>
    );
}
